<script setup lang="ts">
  import { useScrollLock } from '@vueuse/core'
  import { onMounted, ref } from 'vue'
  import { onCreateAnonymousUser } from '~rpc/procedures/user/onCreateAnonymousUser.telefunc'

  const scrollLock = useScrollLock(typeof window !== 'undefined' ? window : null)
  const emit = defineEmits(['close'])

  const username = ref<string>()
  const error = ref<string>()
  const loading = ref<boolean>(false)

  onMounted(() => (scrollLock.value = true))

  const submit = async () => {
    error.value = undefined
    loading.value = true

    try {
      if (!username.value || username.value.length < 3) {
        throw new Error('Username must be at least 3 characters')
      }

      await onCreateAnonymousUser({ username: username.value })
      // Reload to pick up the new auth cookie
      window.location.reload()
    } catch (e: any) {
      error.value = e.message
      loading.value = false
    }
  }

  const close = () => emit('close')
</script>

<template>
  <div
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4"
    @click.self="close"
  >
    <div class="w-full max-w-md rounded-xl border border-[#3b3541] bg-[#211b27] p-8 shadow-2xl">
      <h2
        class="mb-4 bg-linear-to-r from-green-400 to-emerald-600 bg-clip-text text-2xl font-bold text-transparent"
      >
        Who are you?
      </h2>
      <p class="mb-6 text-gray-400">You must choose a username before you can join islands.</p>

      <div class="space-y-4">
        <div>
          <input
            v-model="username"
            @keydown.enter="submit"
            type="text"
            class="w-full rounded-lg border border-[#3b3541] bg-[#292230] px-4 py-2 text-white focus:border-green-400 focus:ring-1 focus:ring-green-400 focus:outline-none"
            placeholder="Enter username"
            autoFocus
          />
        </div>

        <div v-if="error" class="text-sm text-red-400">
          {{ error }}
        </div>

        <button
          @click="submit"
          :disabled="loading"
          class="w-full cursor-pointer rounded-lg bg-green-400 px-6 py-3 font-bold text-black transition-colors hover:bg-green-500 disabled:cursor-not-allowed disabled:opacity-50"
        >
          {{ loading ? 'Joining...' : 'Continue' }}
        </button>
      </div>
    </div>
  </div>
</template>
